import React from "react";
import { withRouter } from "react-router-dom";
import TopHeader from "../../layout/TopHeader";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import apiUrl from "../../apiUrlConstant";
import { ReactMultiEmail } from "react-multi-email";
import { PopupMessage } from "../../utils/utils";
import {getUserRole} from "../../utils/index";
import { Redirect, Link } from "react-router-dom";
import {
  faBell,
  faCheckCircle,
  faPauseCircle,
  faPenSquare,
  faUndo,
  faFileExport,
  faPlus,
  faTrash,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Formik, Form, Field, ErrorMessage } from "formik";
import SimpleReactValidator from "simple-react-validator";
import Accordion from "react-bootstrap/Accordion";
import * as Yup from "yup";


const Schema = Yup.object({
  alertName: Yup.string().required("This field is required"),
  alertText: Yup.string().required("This field is required"),
  reportId: Yup.string().required("This field is required"),
  stateName: Yup.string().required("This field is required"),
  brandSelected: Yup.array().required("Provide at least one tag"),
  frequencySelected: Yup.array().required("Provide at least one tag"),
});



const selectStyles = {
  border: "0",
  background: "#ddd",
};

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class UserNotification extends React.Component {
  state = {
    isModalOpen: false,
    brandSelected: [],
    brandList: [],
    counter: 0,
    counter1: 0,
    assetsList: [],
    states: [],
    leaseList: [],
    regionList: [],
    activeAlert: "expiry",
    currentAlertStatus: "All",
    currentFilterStatus: 0,
    alertList: {
      expiry: [],
      lockin: [],
      rent: [],
      security: [],
      'fitout-security': []
    },
    alertItems: {
      expiry: [],
      lockin: [],
      rent: [],
      security: [],
      'fitout-security': []
    },
    initialValues: {
      regionName: "",
      regiontId: "",
      assetName: "",
      assetId: "",
      stateName: "",
      stateId: "",
      emails: "",
      alertName: "",
      alertText: "",
      frequencySelected: [],
      emails: [],
      selectedStates: [],
      assetSelected: []
    },
    initialValuesAlertSettings: {
      assetTypeId: "",
      assetId: "",
      subAssetId: "",
      towerName: "",
      assetName: "",
      subAssetName: "",
      assetType: "",
      countryId: "",
      stateId: "",
      districtId: "",
      cityId: "",
      frequencySelected: [],
    },
  };
  resetForm(values) {
    this.state.initialValues = {};
    values.stateId = "";
    values.emails = "";
    this.state.leaseSelected = [];
    this.state.initialValues.alertText = "";
    this.state.initialValues.alertName = "";
    this.state.initialValues.assetSelected = [];
    this.state.initialValues.brandSelected = [];
    this.state.initialValues.frequencySelected = [];
    this.setState({});
  }

  componentDidMount() {
    this.state.formUrl = `${apiUrl.apiUrl.url}/user-alert/create-alert`;
    this.fetchStates(1);
    this.fetchBrands();
    this.setState({})
    this.loadAlertsData('expiry');
    this.fetchRegion();
  }

  componentDidUpdate() { }

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  openModal = () => this.setState({ isModalOpen: true });
  closeModal = () => this.setState({ isModalOpen: false });

  frequencyChange(e) {
    this.state.initialValues.frequencySelected = [];
    this.state.initialValuesAlertSettings.freqId = [];
    for (let i = 0; i < e.length; i++) {
      this.state.initialValuesAlertSettings.freqId.push(e[i].value);
      this.state.initialValues.frequencySelected.push({
        value: e[i].value,
        label: e[i].label,
      });
    }
    this.setState({});
  }

  fetchRegion = () => {

    fetch(`${apiUrl.apiUrl.url}/user-alert/get-region/`, {
      method: 'GET', // Specify the HTTP method (GET, POST, etc.)
      headers
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          regionList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  fetchStates = (countryId, region = null) => {
    let url = apiUrl.apiUrl.url + "/user-alert/get-state";
    if (region !== null) {
      url = apiUrl.apiUrl.url + "/user-alert/get-state?region=" + region;
    }

    fetch(`${url}`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  fetchBrands = () => {
    let url = apiUrl.apiUrl.url + "/brand/get-all-brands";
    if (this.state.initialValues.regionName != '' && this.state.initialValues.regionName != 'ALL') {
      let regionName = this.state.initialValues.regionName != '' && this.state.initialValues.regionName != 'ALL' ? this.state.initialValues.regionName : '';
      url = apiUrl.apiUrl.url + "/brand/get-region-brands?region=" + regionName;
    }

    fetch(url, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getAssetsListByBrand = () => {
    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-brand-asset-list?brandId=` +
      this.state.initialValues.brandId + `&state_id=` + this.state.initialValues.stateId + `&region=` + this.state.initialValues.regionName,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/lease-view/get-lease-list?all=true&brand=` +
      this.state.initialValues.brandId +
      "&asset=" +
      this.state.initialValues.assetId +
      "&brandCategory=" +
      this.state.initialValues.brandCatId +
      "&region=" +
      this.state.initialValues.regionName,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          leaseList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  fetchLeases = () => {
    fetch(`${apiUrl.apiUrl.url
      }/lease-view/get-revenue-lease-list?all=true&brand=` + this.state.initialValues.brandId + "&asset=" + this.state.initialValues.assetId + "&brandCategory=" + this.state.initialValues.brandCatId + "&leaseType=" + this.state.leaseType + "&stateId=" + this.state.initialValues.stateId, { headers }).then((response) => {
        return response.json();
      }).then((data) => {
        this.setState({ leaseList: data });

        this.state.initialValues.leaseValue = [];
        //this.state.initialValues.leaseId = [];
      }).catch((error) => {
        console.log(error);
      });
  }

  valueChange = (newValue, actionMeta) => {
    console.log("newVa calling..", newValue, "meta", actionMeta);

    // newValue.value = newValue.target.value;
    // newValue.label = newValue.target.value;

    if (actionMeta == "change_state") {

      // selectedStates
      this.state.initialValues.stateId = newValue.value;
      this.state.initialValues.stateName = newValue.label;
      // this.state.initialValues.selectedStates = [];
      // for (let i = 0; i < newValue.length; i++) { // this.state.selectedValue.push(newValue[i].value);
      //     this.state.initialValues.selectedStates.push({value: newValue[i].value, label: newValue[i].label});
      // }

      //this.fetchBrands(newValue.value)
      this.setState({})

      // districtList
    } else if (actionMeta == "change_brand") {
      this.state.initialValues.brandSelected = [];
      this.state.initialValues.brandId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.brandId.push(newValue[i].value);
        this.state.initialValues.brandSelected.push({ value: newValue[i].value, label: newValue[i].label });
      }
      this.getAssetsListByBrand();
      fetch(`${apiUrl.apiUrl.url
        }/lease-view/get-lease-list?all=true&brand=` + this.state.initialValues.brandId + "&asset=" + this.state.initialValues.assetId + "&brandCategory=" + this.state.initialValues.brandCatId, { headers }).then((response) => {
          return response.json();
        }).then((data) => {
          this.setState({ leaseList: data });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        }).catch((error) => {
          console.log(error);
        });

      console.log(this.state.initialValues, "this.state.initialValues");
    } else if (actionMeta == "change_asset_name") { // change_lease_month
      this.state.initialValues.assetSelected = [];
      this.state.initialValues.assetId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.assetId.push(newValue[i].value);
        this.state.initialValues.assetSelected.push({ value: newValue[i].value, label: newValue[i].label });
      }
      // this.setMasterPreValues(newValue.value);
      this.fetchLeases();

    } else if (actionMeta == "change_lease_number") { // change_document_type

      this.state.leaseSelected = [];
      if (newValue.length == 0) {
        this.state.initialValues.leaseId = "";
      } else {
        this.state.initialValues.leaseId = [];
      }
      if (newValue.length > 0 && newValue[0].value == 0) {
        this.state.leaseSelected.push({ value: newValue[0].value, label: newValue[0].label });

        for (let i = 0; i < this.state.leaseList.length; i++) {
          if (this.state.leaseList[i].id != 0) {
            this.state.initialValues.leaseId.push(this.state.leaseList[i].id);
          }
        }
      } else {
        for (let i = 0; i < newValue.length; i++) {
          this.state.initialValues.leaseId.push(newValue[i].value);
          // this.state.selectedValue.push(newValue[i].value);
          this.state.leaseSelected.push({ value: newValue[i].value, label: newValue[i].label });
        }
      }
    } else if (actionMeta == "change_alert_text") { // this.state.initialValues.countryId = newValue.value;
      this.state.initialValues.alertText = newValue.target.value;
    } else if (actionMeta == "change_alert") { // this.state.initialValues.countryId = newValue.value;
      this.state.initialValues.alertName = newValue.target.value;
    } else if (actionMeta == "change_region") {
      this.state.initialValues.regiontId = newValue.value;
      this.state.initialValues.regionName = newValue.label;

      this.state.initialValues.stateId = '';
      this.state.initialValues.stateName = '';

      this.state.initialValues.brandSelected = [];
      this.state.initialValues.brandId = [];

      this.state.initialValues.assetSelected = [];
      this.state.initialValues.assetId = [];

      this.state.initialValues.leaseValue = [];
      this.state.initialValues.leaseId = [];

      this.fetchStates(1, newValue.value);
      this.fetchBrands();
      this.setState({})
    } else {
      this.state.initialValues.countryId = newValue.value;
      this.state.initialValues.countryName = newValue.label;
    }
    this.setState({});
  };

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        assetName: "",
        assetId: "",
        stateName: "",
        stateId: "",
        emails: "",
        alertName: "",
        alertText: "",
        frequencySelected: [],
        emails: [],
      },
    });
  };

  downloadReport = () => {
    // fetch(`${
    //   apiUrl.apiUrl.url
    //   }/user-alert/export?` , {headers}).then((response) => {
    //       return response.json();
    //   }).then((data) => {
    //       console.log(data, "export data");
    //       //window.location.href= `${apiUrl.apiUrl.url+'/lease-report/download-file?path='+data.data}`;
    //   }).catch((error) => {
    //       console.log(error);
    //   });

    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url + '/user-alert/export'}`,
      data: {}
    }).then(function (response) {
      window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + response.data}`;
    });
  }

  loadAlertsData = (type) => {

    this.state.activeAlert = type;
    fetch(`${apiUrl.apiUrl.url
      }/user-alert/get-alert-list?type=` + type + `&status=` + this.state.currentAlertStatus, { headers }).then((response) => {
        return response.json();
      }).then((data) => {
        this.state.alertList[type] = data.data;
        this.state.counter = Math.round();
        console.log(this.state.alertList[type], "this.state.alertList[type]");
        this.setState({});
      }).catch((error) => {
        console.log(error);
      });
  }

  //alertItems

  loadAlertsList = (type, id) => {
    //this.state.alertItems[type][id] = [];
    fetch(`${apiUrl.apiUrl.url
      }/user-alert/get-alert-details?id=` + id, { headers }).then((response) => {
        return response.json();
      }).then((data) => {
        this.state.alertItems[type][id] = data.data;
        console.log(this.state.alertItems[type][id], "this.state.alertItems[type]", type, "==", id);
        this.setState({});

      }).catch((error) => {
        console.log(error);
      });
  }

  openCreateModal = () => {
    this.openModal();
    this.state.formUrl = `${apiUrl.apiUrl.url}/user-alert/create-alert`;
    this.setState({});
  }

  pauseAlert = (settingId, leaseId = 0, frequency = '', lease_expiry_date = '') => {
    //this.openModal();
    //alert(settingId)
    var self = this;
    // this.state.formUrl = `${apiUrl.apiUrl.url}/user-alert/update-alert?id=` + alertId + `&leaseId=` + leaseId;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/user-alert/pause-alert`,
      data: { 'id': settingId, 'lease_id': leaseId, 'frequency': frequency, 'lease_expiry_date': lease_expiry_date },
    }).then(function (response) {
      if (!response.data.success) {
        alert(response.data.message);
      } else {
        self.setState({
          messsagePopup: true,
          popupContent: "Data Saved Successfully",
        });
        self.state.alertItems[self.state.activeAlert][settingId] = response.data.data;
        //   console.log(this.state,"this.state");
        self.loadAlertsData(self.state.activeAlert);
        self.setState({});
      }
    });
  }
  markAsDone = (settingId, leaseId = 0, frequency = '', lease_expiry_date = '') => {
    //this.openModal();
    //alert(settingId)
    var self = this;
    // this.state.formUrl = `${apiUrl.apiUrl.url}/user-alert/update-alert?id=` + alertId + `&leaseId=` + leaseId;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/user-alert/mark-as-done`,
      data: { 'id': settingId, 'lease_id': leaseId, 'frequency': frequency, 'lease_expiry_date': lease_expiry_date },

    }).then(function (response) {
      if (!response.data.success) {
        alert(response.data.message);
      } else {
        self.setState({
          messsagePopup: true,
          popupContent: "Data Saved Successfully",
        });

        self.state.alertItems[self.state.activeAlert][settingId] = response.data.data;
        self.loadAlertsData(self.state.activeAlert);
        self.setState({});

      }
    });
  }

  deleteAlert = (settingId) => {
    var self = this;
    // this.state.formUrl = `${apiUrl.apiUrl.url}/user-alert/update-alert?id=` + alertId + `&leaseId=` + leaseId;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/user-alert/delete-alert`,
      data: { 'id': settingId },

    }).then(function (response) {
      if (!response.data.success) {
        alert(response.data.message);
      } else {
        self.setState({
          messsagePopup: true,
          popupContent: "Data Saved Successfully",
        });
        self.loadAlertsData(self.state.activeAlert);
      }
    });
  }

  editAlert = (alertId, leaseId = 0) => {
    this.openModal();
    this.state.formUrl = `${apiUrl.apiUrl.url}/user-alert/update-alert?id=` + alertId + `&leaseId=` + leaseId;
    fetch(`${apiUrl.apiUrl.url
      }/user-alert/fetch-alert?id=` + alertId + `&leaseId=` + leaseId, { headers }).then((response) => {
        return response.json();
      }).then((data) => {
        console.log(data, "data");
        this.state.initialValues = {
          assetName: data.data.alert_name,
          assetId: data.data.assets,
          stateName: data.data.state.label,
          stateId: data.data.state.value,
          emails: data.data.emails.split(","),
          alertName: data.data.alert_name,
          alertText: data.data.alert_text,
          frequencySelected: data.data.frequency, // .split(",")
          selectedStates: data.data.state,
          brandSelected: data.data.brands,
          assetSelected: data.data.assets,
          assetId: data.assetIdArr,
          brandId: data.brandIdArr,
          leaseId: data.data.leaseId,
          regionName: data.data.region,
          regionId: data.data.region
        };
        this.state.leaseSelected = data.leaseIdArr;
        this.state.initialValues.reportType = data.data.type.label
        this.state.initialValues.reportId = data.data.type.value

        console.log(leaseId, "leaseId");
        if (leaseId == 0) {
          this.getAssetsListByBrand();
          this.fetchLeases();
        }


        this.state.initialValues.leaseId = data.leaseId;
        //this.state.initialValues.brandName = data.data.brands.label
        //this.state.initialValues.brandId = data.data.brands.value

        this.setState({});
      }).catch((error) => {
        console.log(error);
      });
  };

  submitForm = (values) => {
    console.log(this.validator.allValid());
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      return false;
    }


    console.log(values, "asdas", this.state);
    var self = this;
    this.state.initialValues.leaseSelected = this.state.leaseSelected;
    axios({
      method: "post",
      url: this.state.formUrl, //`${apiUrl.apiUrl.url}/user-alert/create-alert`,
      data: this.state.initialValues,
    }).then(function (response) {
      if (!response.data.success) {
        alert("Please fill all the fields.");
      } else {
        self.closeModal();
        self.setState({
          messsagePopup: true,
          popupContent: "Data Saved Successfully",
        });
        self.loadAlertsData(self.state.activeAlert);
        self.setState({
          // url: `${apiUrl.apiUrl.url}/asset/create-tower`,
          // self.setState({ redirect: true });
          redirect: true,
          emails: [],
          frequencySelected: [],
          isOpen: false,
          initialValues: {
            assetName: "",
            assetId: "",
            stateName: "",
            stateId: "",
            emails: "",
            alertName: "",
            alertText: "",
            frequencySelected: [],
            emails: [],
          },
        });
      }
    });
  };

  render() {
    const { isOpen } = this.state;

    return this.renderForm();
  }
  renderForm() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/user/alerts/alerts" />;
    }
    console.log(window.location.pathname)
    return (
      <>
        <div className="parentContainer">
          <TopHeader />
          <div className="absoluteItemForTopBar d-flex align-items-center gap-4">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li>Alerts</li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>My Alerts</li>
              </ul>
            </div>
             {!["checker", "user"].includes(getUserRole()) && (
            <button
              className="create_lease_landlord"
              onClick={this.openCreateModal}
            >
              Create Alert
            </button>
            )}

          </div>
          <div className="masterContainer mt-4 padding_left_class">
            <Tabs key={this.state.counter1} className="tabGridMain">
              <div className="tabGridMainL">
                <div className="d-grid gap-4">
                  <div className="tabGridMainLFilter d-flex justify-content-between align-items-center">
                    <div className="gridTempCol2">
                      <select
                        onChange={(e) => {
                          this.state.currentAlertStatus = e.target.value;
                          this.setState({});
                          this.loadAlertsData(this.state.activeAlert);
                        }}
                      >
                        <option>All</option>
                        <option>Active</option>
                        <option>Pause</option>
                        <option>Done</option>
                      </select>
                      <select
                        onChange={(e) => {
                          this.state.currentFilterStatus = e.target.value;
                          this.setState({});
                        }}
                      >
                        <option value='0' >All</option>
                        <option value='1' >Pause</option>
                        <option value='2' >Mark As Done</option>
                        <option value='3' >Sent</option>
                      </select>
                    </div>
                    <button class="resetBtn"
                      onClick={(e) => {
                        this.state.activeAlert = "expiry";
                        this.state.currentAlertStatus = "All";
                        this.state.counter1 = Math.round();
                        this.state.redirect = true;
                        this.setState({});
                      }}>
                      <img src="/images/icons/reset.svg" alt="Reset Filters" />
                    </button>
                  </div>
                  <hr className="m-0" style={{ borderColor: "#c2c2c2" }} />
                  <TabList>
                    <Tab onClick={() => this.loadAlertsData('expiry')} >Lease Expiry </Tab>
                    <Tab onClick={() => this.loadAlertsData('lockin')} >Lease Lockin</Tab>
                    <Tab onClick={() => this.loadAlertsData('rent')}  >Rent</Tab>
                    <Tab onClick={() => this.loadAlertsData('security')}  >Security Deposit	</Tab>
                    <Tab onClick={() => this.loadAlertsData('fitout-security')}  >Fitout Security Deposit	</Tab>
                  </TabList>
                </div>
                <button className="export_button"
                  onClick={(e) => {
                    this.downloadReport();
                  }}
                >
                  <FontAwesomeIcon icon={faFileExport} /> Export
                </button>
              </div>

              <div className="tabGridMainR">
                <TabPanel key={this.state.counter}>
                  {this.state.alertList["expiry"].map((name, index) => (
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item>
                        <Accordion.Header>
                          <div className="arrordianHeaderMain">
                            <div className="arrordianHeaderL">
                              <h4 onClick={() => this.loadAlertsList("expiry", name.id)}>{name.alert_name}</h4>
                            </div>
                            <div className="arrordianHeaderM">
                              <h4 className="text-center" onClick={() => this.loadAlertsList("expiry", name.id)}>
                                {name.created_at} <span>(Date Created)</span>
                              </h4>
                            </div>
                            <div className="arrordianHeaderR d-flex justify-content-end align-items-center gap-5 me-3">
                              <button className="noBorderBgOutline" title="Pause Alert" onClick={() => this.pauseAlert(name.id)}>
                                <svg className={`${name.pause_status ? "warningColor" : ""}`} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                  <path fill="currentColor" d="M14 10h-2v12h2zm6 0h-2v12h2z" />
                                  <path fill="currentColor" d="M16 4A12 12 0 1 1 4 16A12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" />
                                </svg>
                              </button>
                              <button title="Mark as Done" className="noBorderBgOutline" onClick={() => this.markAsDone(name.id)} >
                                <svg className={`${name.mark_as_done ? "markAsDone" : ""}`} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <g fill="white">
                                    <path d="M10.243 16.314L6 12.07l1.414-1.414l2.829 2.828l5.656-5.657l1.415 1.415z" />
                                    <path fill-rule="evenodd" d="M1 5a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4zm4-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2" clip-rule="evenodd" />
                                  </g>
                                </svg>
                                {/* <FontAwesomeIcon icon={faCheckCircle} /> */}
                              </button>
                              <button className="noBorderBgOutline">
                                {/* <FontAwesomeIcon icon={faBell} /> */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 8.4c0-1.697-.632-3.325-1.757-4.525S13.59 2 12 2s-3.117.674-4.243 1.875C6.632 5.075 6 6.703 6 8.4C6 15.867 3 18 3 18h18s-3-2.133-3-9.6M13.73 21a2 2 0 0 1-3.46 0" />
                                </svg>
                              </button>
                              <button title="Change Alert Date" className="noBorderBgOutline" onClick={() => this.editAlert(name.id)} >
                                {/* <FontAwesomeIcon icon={faPenSquare} /> */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <path fill="none" stroke="currentColor" stroke-width="1.5" d="m14.36 4.079l.927-.927a3.932 3.932 0 0 1 5.561 5.561l-.927.927m-5.56-5.561s.115 1.97 1.853 3.707C17.952 9.524 19.92 9.64 19.92 9.64m-5.56-5.561l-8.522 8.52c-.577.578-.866.867-1.114 1.185a6.556 6.556 0 0 0-.749 1.211c-.173.364-.302.752-.56 1.526l-1.094 3.281m17.6-10.162L11.4 18.16c-.577.577-.866.866-1.184 1.114a6.554 6.554 0 0 1-1.211.749c-.364.173-.751.302-1.526.56l-3.281 1.094m0 0l-.802.268a1.06 1.06 0 0 1-1.342-1.342l.268-.802m1.876 1.876l-1.876-1.876" />
                                </svg>
                              </button>
                              <button title="Delete Alert" className="noBorderBgOutline" onClick={() => this.deleteAlert(name.id)} >
                                {/* <FontAwesomeIcon icon={faTrash} /> */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                  <path fill="currentColor" d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body style={{ maxHeight: "450px", overflowY: "auto" }}>
                          {typeof this.state.alertItems["expiry"][name.id] != "undefined" && this.state.alertItems["expiry"][name.id].filter(filterItem => (this.state.currentFilterStatus == 0 || (filterItem.pause_status == 1 && this.state.currentFilterStatus == 1) || (this.state.currentFilterStatus == 2 && filterItem.mark_as_done == 1) || (this.state.currentFilterStatus == 3 && filterItem.sent_status == 1))).map((leaseDetails, index1) => (
                            <>
                              <div className="arrordianHeaderMain">
                                <div className="arrordianHeaderL">
                                  <h4>{leaseDetails.lease_code}</h4>
                                  <p>{leaseDetails.tower}, {leaseDetails.asset}</p>
                                </div>
                                <div className="arrordianHeaderM">
                                  <h4 className="text-center">
                                    {leaseDetails.lease_expiry_date} <span>(in {leaseDetails.days_remaining} Days)</span>
                                  </h4>
                                </div>
                                <div className="arrordianHeaderR d-flex justify-content-end align-items-center gap-5">
                                  <button title="Pause Alert" className="noBorderBgOutline" onClick={() => this.pauseAlert(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <svg className={leaseDetails.pause_status ? "warningColor" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                      <path fill="currentColor" d="M14 10h-2v12h2zm6 0h-2v12h2z" />
                                      <path fill="currentColor" d="M16 4A12 12 0 1 1 4 16A12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" />
                                    </svg>
                                  </button>
                                  <button title="Mark as Done" className="noBorderBgOutline" onClick={() => this.markAsDone(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <svg className={leaseDetails.mark_as_done ? "markAsDone" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                                        <rect width="18" height="18" x="3" y="3" rx="4" />
                                        <path d="m9 12l2.25 2L15 10" />
                                      </g>
                                    </svg>
                                  </button>
                                  <button className="noBorderBgOutline">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 8.4c0-1.697-.632-3.325-1.757-4.525S13.59 2 12 2s-3.117.674-4.243 1.875C6.632 5.075 6 6.703 6 8.4C6 15.867 3 18 3 18h18s-3-2.133-3-9.6M13.73 21a2 2 0 0 1-3.46 0" />
                                    </svg>
                                  </button>
                                  <button title="Change Alert Date" className="noBorderBgOutline" onClick={() => this.editAlert(name.id, leaseDetails.lease_id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <path fill="none" stroke="currentColor" stroke-width="1.5" d="m14.36 4.079l.927-.927a3.932 3.932 0 0 1 5.561 5.561l-.927.927m-5.56-5.561s.115 1.97 1.853 3.707C17.952 9.524 19.92 9.64 19.92 9.64m-5.56-5.561l-8.522 8.52c-.577.578-.866.867-1.114 1.185a6.556 6.556 0 0 0-.749 1.211c-.173.364-.302.752-.56 1.526l-1.094 3.281m17.6-10.162L11.4 18.16c-.577.577-.866.866-1.184 1.114a6.554 6.554 0 0 1-1.211.749c-.364.173-.751.302-1.526.56l-3.281 1.094m0 0l-.802.268a1.06 1.06 0 0 1-1.342-1.342l.268-.802m1.876 1.876l-1.876-1.876" />
                                    </svg>
                                  </button>
                                  <button title="Delete Alert" className="noBorderBgOutline opacity-0" onClick={() => this.deleteAlert(name.id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                      <path fill="currentColor" d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z" />
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            </>
                          ))
                          }
                          {
                            (typeof this.state.alertItems["expiry"][name.id] == "undefined" || this.state.alertItems["expiry"][name.id].length == 0) && (
                              <center><h7>No Data</h7></center>
                            )
                          }
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ), this)
                  }
                  {this.state.alertList["expiry"].length == 0 && <p className="noDataFound">No data</p>}

                </TabPanel>
                <TabPanel>
                  {this.state.alertList["lockin"].map((name, index) => (
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item>
                        <Accordion.Header>
                          <div className="arrordianHeaderMain">
                            <div className="arrordianHeaderL">
                              <h4 onClick={() => this.loadAlertsList("lockin", name.id)}>
                                {name.alert_name}
                              </h4>
                            </div>

                            <div className="arrordianHeaderM">
                              <h4 className="text-center" onClick={() => this.loadAlertsList("lockin", name.id)}>
                                {name.created_at} <span>(Date Created)</span>
                              </h4>
                            </div>

                            <div className="arrordianHeaderR d-flex justify-content-end align-items-center gap-5 me-3">
                              <button title="Pause Alert" className="noBorderBgOutline" onClick={() => this.pauseAlert(name.id)}>
                                <svg className={name.pause_status ? "warningColor" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                  <path fill="currentColor" d="M14 10h-2v12h2zm6 0h-2v12h2z" />
                                  <path fill="currentColor" d="M16 4A12 12 0 1 1 4 16A12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" />
                                </svg>
                              </button>

                              <button title="Mark as Done" className="noBorderBgOutline" onClick={() => this.markAsDone(name.id)}>
                                <svg className={`${name.mark_as_done ? "markAsDone" : ""}`} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <g fill="white">
                                    <path d="M10.243 16.314L6 12.07l1.414-1.414l2.829 2.828l5.656-5.657l1.415 1.415z" />
                                    <path fill-rule="evenodd" d="M1 5a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4zm4-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2" clip-rule="evenodd" />
                                  </g>
                                </svg>
                              </button>

                              <button className="noBorderBgOutline">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 8.4c0-1.697-.632-3.325-1.757-4.525S13.59 2 12 2s-3.117.674-4.243 1.875C6.632 5.075 6 6.703 6 8.4C6 15.867 3 18 3 18h18s-3-2.133-3-9.6M13.73 21a2 2 0 0 1-3.46 0" />
                                </svg>
                              </button>

                              <button title="Change Alert Date" className="noBorderBgOutline" onClick={() => this.editAlert(name.id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <path fill="none" stroke="currentColor" stroke-width="1.5" d="m14.36 4.079l.927-.927a3.932 3.932 0 0 1 5.561 5.561l-.927.927m-5.56-5.561s.115 1.97 1.853 3.707C17.952 9.524 19.92 9.64 19.92 9.64m-5.56-5.561l-8.522 8.52c-.577.578-.866.867-1.114 1.185a6.556 6.556 0 0 0-.749 1.211c-.173.364-.302.752-.56 1.526l-1.094 3.281m17.6-10.162L11.4 18.16c-.577.577-.866.866-1.184 1.114a6.554 6.554 0 0 1-1.211.749c-.364.173-.751.302-1.526.56l-3.281 1.094m0 0l-.802.268a1.06 1.06 0 0 1-1.342-1.342l.268-.802m1.876 1.876l-1.876-1.876" />
                                </svg>
                              </button>

                              <button title="Delete Alert" className="noBorderBgOutline" onClick={() => this.deleteAlert(name.id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                  <path fill="currentColor" d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          {/* { typeof this.state.alertItems["lockin"][name.id] != "undefined" && this.state.alertItems["lockin"][name.id]].filter(filterItem => ( this.state.currentFilterStatus == 0 || (filterItem.pause_status == 1 && this.state.currentFilterStatus == 1 ) || ( this.state.currentFilterStatus == 2 && filterItem.mark_as_done == 1 ) || ( this.state.currentFilterStatus == 3 && filterItem.sent_status == 1 ) ) ).map((leaseDetails, index1) => ( */}
                          {/* {typeof this.state.alertItems["lockin"][name.id] != "undefined" && this.state.alertItems["lockin"][name.id].filter(filterItem => (this.state.currentFilterStatus == 0 || (filterItem.pause_status == 1 && this.state.currentFilterStatus == 1) || (this.state.currentFilterStatus == 2 && filterItem.mark_as_done == 1) || (this.state.currentFilterStatus == 3 && filterItem.sent_status == 1))).map((leaseDetails, index1) => (
                            <div className="row my-3 bodyContentDiv">
                              <div className="col-lg-3">
                                <h4>{leaseDetails.lease_code} </h4>
                                <p>{leaseDetails.tower}, {leaseDetails.asset}</p>
                              </div>
                              <div className="col-lg-2">
                                <h4>
                                  {leaseDetails.lease_expiry_date} <span>(in {leaseDetails.days_remaining} Days)</span>
                                </h4>
                              </div>
                              <div className="col-lg-2">
                                <h4>&nbsp;</h4>
                                <p>&nbsp;</p>
                              </div>
                              <div className={`col-lg-1 text-center ${leaseDetails.pause_status ? "warningColor" : ""}`}>
                                <h4 onClick={() => this.pauseAlert(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                  <FontAwesomeIcon icon={faPauseCircle} />
                                </h4 >
                                <p>Pause Alert</p>
                              </div>
                              <div className={`col-lg-1 text-center ${leaseDetails.mark_as_done ? "markAsDone" : ""}`} >
                                <h4 onClick={() => this.markAsDone(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                  <FontAwesomeIcon icon={faCheckCircle} />
                                </h4>
                                <p>Mark as Done</p>
                              </div>
                              <div className="col-lg-1 text-center">
                                <h4 onClick={() => this.editAlert(name.id, leaseDetails.lease_id)} >
                                  <FontAwesomeIcon icon={faBell} />
                                </h4>
                                <p>Change Alert Date</p>
                              </div>
                              <div className="col-lg-1 text-center">
                                <h4 onClick={() => this.editAlert(name.id, leaseDetails.lease_id)} >
                                  <FontAwesomeIcon icon={faPenSquare} />
                                </h4>
                                <p>Edit Alert</p>
                              </div>
                            </div>
                          ))} */}
                          {typeof this.state.alertItems["lockin"][name.id] != "undefined" && this.state.alertItems["lockin"][name.id].filter(filterItem => (this.state.currentFilterStatus == 0 || (filterItem.pause_status == 1 && this.state.currentFilterStatus == 1) || (this.state.currentFilterStatus == 2 && filterItem.mark_as_done == 1) || (this.state.currentFilterStatus == 3 && filterItem.sent_status == 1))).map((leaseDetails, index1) => (
                            <>
                              {/* {console.log(this.state.alertItems["lockin"], "this.state.alertItems[lockin]"), '\n', this.state.alertItems["lockin"][name.id], "this.state.alertItems[lockin][name.id]", '\n', this.state.currentFilterStatus, "this.state.currentFilterStatus"} */}
                              <div className="arrordianHeaderMain">
                                <div className="arrordianHeaderL">
                                  <h4>{leaseDetails.lease_code}</h4>
                                  <p>{leaseDetails.tower}, {leaseDetails.asset}</p>
                                </div>
                                <div className="arrordianHeaderM">
                                  <h4 className="text-center">
                                    {leaseDetails.lease_expiry_date} <span>(in {leaseDetails.days_remaining} Days)</span>
                                  </h4>
                                </div>
                                <div className="arrordianHeaderR d-flex justify-content-end align-items-center gap-5">
                                  <button title="Pause Alert" className="noBorderBgOutline" onClick={() => this.pauseAlert(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <svg className={leaseDetails.pause_status ? "warningColor" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                      <path fill="currentColor" d="M14 10h-2v12h2zm6 0h-2v12h2z" />
                                      <path fill="currentColor" d="M16 4A12 12 0 1 1 4 16A12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" />
                                    </svg>
                                  </button>
                                  <button title="Mark as Done" className="noBorderBgOutline" onClick={() => this.markAsDone(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <svg className={leaseDetails.mark_as_done ? "markAsDone" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                                        <rect width="18" height="18" x="3" y="3" rx="4" />
                                        <path d="m9 12l2.25 2L15 10" />
                                      </g>
                                    </svg>
                                  </button>
                                  <button className="noBorderBgOutline">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 8.4c0-1.697-.632-3.325-1.757-4.525S13.59 2 12 2s-3.117.674-4.243 1.875C6.632 5.075 6 6.703 6 8.4C6 15.867 3 18 3 18h18s-3-2.133-3-9.6M13.73 21a2 2 0 0 1-3.46 0" />
                                    </svg>
                                  </button>
                                  <button title="Change Alert Date" className="noBorderBgOutline" onClick={() => this.editAlert(name.id, leaseDetails.lease_id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <path fill="none" stroke="currentColor" stroke-width="1.5" d="m14.36 4.079l.927-.927a3.932 3.932 0 0 1 5.561 5.561l-.927.927m-5.56-5.561s.115 1.97 1.853 3.707C17.952 9.524 19.92 9.64 19.92 9.64m-5.56-5.561l-8.522 8.52c-.577.578-.866.867-1.114 1.185a6.556 6.556 0 0 0-.749 1.211c-.173.364-.302.752-.56 1.526l-1.094 3.281m17.6-10.162L11.4 18.16c-.577.577-.866.866-1.184 1.114a6.554 6.554 0 0 1-1.211.749c-.364.173-.751.302-1.526.56l-3.281 1.094m0 0l-.802.268a1.06 1.06 0 0 1-1.342-1.342l.268-.802m1.876 1.876l-1.876-1.876" />
                                    </svg>
                                  </button>
                                  <button title="Delete Alert" className="noBorderBgOutline opacity-0" onClick={() => this.deleteAlert(name.id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                      <path fill="currentColor" d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z" />
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            </>
                          ))}
                          {(typeof this.state.alertItems["lockin"][name.id] == "undefined" || this.state.alertItems["lockin"][name.id].length == 0) && (
                            <center><h7>No Data</h7></center>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ), this)
                  }
                  {this.state.alertList["lockin"].length == 0 && <p className="noDataFound">No data</p>}

                </TabPanel>
                <TabPanel>
                  {this.state.alertList["rent"].map((name, index) => (
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item>
                        <Accordion.Header>
                          <div className="arrordianHeaderMain">
                            <div className="arrordianHeaderL">
                              <h4 onClick={() => this.loadAlertsList("rent", name.id)}>
                                {name.alert_name}
                              </h4>
                            </div>
                            <div className="arrordianHeaderM">
                              <h4 className="text-center" onClick={() => this.loadAlertsList("rent", name.id)}>
                                {name.created_at} <span>(Date Created)</span>
                              </h4>
                            </div>
                            <div className="arrordianHeaderR d-flex justify-content-end align-items-center gap-5 me-3">
                              <button title="Pause Alert" className="noBorderBgOutline" onClick={() => this.pauseAlert(name.id)}>
                                <svg className={name.pause_status ? "warningColor" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                  <path fill="currentColor" d="M14 10h-2v12h2zm6 0h-2v12h2z" />
                                  <path fill="currentColor" d="M16 4A12 12 0 1 1 4 16A12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" />
                                </svg>
                              </button>
                              <button title="Mark as Done" className="noBorderBgOutline" onClick={() => this.markAsDone(name.id)}>
                                <svg className={`${name.mark_as_done ? "markAsDone" : ""}`} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <g fill="white">
                                    <path d="M10.243 16.314L6 12.07l1.414-1.414l2.829 2.828l5.656-5.657l1.415 1.415z" />
                                    <path fill-rule="evenodd" d="M1 5a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4zm4-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2" clip-rule="evenodd" />
                                  </g>
                                </svg>
                              </button>
                              <button className="noBorderBgOutline">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 8.4c0-1.697-.632-3.325-1.757-4.525S13.59 2 12 2s-3.117.674-4.243 1.875C6.632 5.075 6 6.703 6 8.4C6 15.867 3 18 3 18h18s-3-2.133-3-9.6M13.73 21a2 2 0 0 1-3.46 0" />
                                </svg>
                              </button>
                              <button title="Change Alert Date" className="noBorderBgOutline" onClick={() => this.editAlert(name.id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <path fill="none" stroke="currentColor" stroke-width="1.5" d="m14.36 4.079l.927-.927a3.932 3.932 0 0 1 5.561 5.561l-.927.927m-5.56-5.561s.115 1.97 1.853 3.707C17.952 9.524 19.92 9.64 19.92 9.64m-5.56-5.561l-8.522 8.52c-.577.578-.866.867-1.114 1.185a6.556 6.556 0 0 0-.749 1.211c-.173.364-.302.752-.56 1.526l-1.094 3.281m17.6-10.162L11.4 18.16c-.577.577-.866.866-1.184 1.114a6.554 6.554 0 0 1-1.211.749c-.364.173-.751.302-1.526.56l-3.281 1.094m0 0l-.802.268a1.06 1.06 0 0 1-1.342-1.342l.268-.802m1.876 1.876l-1.876-1.876" />
                                </svg>
                              </button>
                              <button title="Delete Alert" className="noBorderBgOutline" onClick={() => this.deleteAlert(name.id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                  <path fill="currentColor" d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z" />
                                </svg>
                              </button>
                            </div>
                          </div>

                        </Accordion.Header>
                        <Accordion.Body>
                          {/* { typeof this.state.alertItems["rent"][name.id] != "undefined" && this.state.alertItems["rent"][name.id]].filter(filterItem => ( this.state.currentFilterStatus == 0 || (filterItem.pause_status == 1 && this.state.currentFilterStatus == 1 ) || ( this.state.currentFilterStatus == 2 && filterItem.mark_as_done == 1 ) || ( this.state.currentFilterStatus == 3 && filterItem.sent_status == 1 ) ) ).map((leaseDetails, index1) => ( */}

                          {typeof this.state.alertItems["rent"][name.id] != "undefined" && this.state.alertItems["rent"][name.id].filter(filterItem => (this.state.currentFilterStatus == 0 || (filterItem.pause_status == 1 && this.state.currentFilterStatus == 1) || (this.state.currentFilterStatus == 2 && filterItem.mark_as_done == 1) || (this.state.currentFilterStatus == 3 && filterItem.sent_status == 1))).map((leaseDetails, index1) => (
                            <>
                              {/* <div className="row my-3 bodyContentDiv">
                                <div className="col-lg-3">
                                  <h4>{leaseDetails.lease_code} </h4>
                                  <p>{leaseDetails.tower}, {leaseDetails.asset}</p>
                                </div>
                                <div className="col-lg-2">
                                  <h4>
                                    {leaseDetails.lease_expiry_date} <span>(in {leaseDetails.days_remaining} Days)</span>
                                  </h4>
                                </div>
                                <div className="col-lg-2">
                                  <h4>Rs.{leaseDetails.rent} / mo Rent</h4>
                                  <p>{leaseDetails.gross_leasable_area} sqft </p>
                                </div>
                                <div className={`col-lg-1 text-center ${leaseDetails.pause_status ? "warningColor" : ""}`}>
                                  <h4 onClick={() => this.pauseAlert(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <FontAwesomeIcon icon={faPauseCircle} />
                                  </h4 >
                                  <p>Pause Alert</p>
                                </div>
                                <div className={`col-lg-1 text-center ${leaseDetails.mark_as_done ? "markAsDone" : ""}`} >
                                  <h4 onClick={() => this.markAsDone(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <FontAwesomeIcon icon={faCheckCircle} />
                                  </h4>
                                  <p>Mark as Done</p>
                                </div>
                                <div className="col-lg-1 text-center">
                                  <h4 onClick={() => this.editAlert(name.id, leaseDetails.lease_id)} >
                                    <FontAwesomeIcon icon={faBell} />
                                  </h4>
                                  <p>Change Alert Date</p>
                                </div>
                                <div className="col-lg-1 text-center">
                                  <h4 onClick={() => this.editAlert(name.id, leaseDetails.lease_id)} >
                                    <FontAwesomeIcon icon={faPenSquare} />
                                  </h4>
                                  <p>Edit Alert</p>
                                </div>
                              </div> */}
                              <div className="arrordianHeaderMain" key={index1}>
                                <div className="arrordianHeaderL">
                                  <h4>{leaseDetails.lease_code}</h4>
                                  <p>{leaseDetails.tower}, {leaseDetails.asset}</p>
                                </div>
                                <div className="arrordianHeaderM text-center">
                                  <h4>
                                    {leaseDetails.lease_expiry_date} <span>(in {leaseDetails.days_remaining} Days)</span>
                                  </h4>
                                  <p>Rs.{leaseDetails.rent} / mo Rent (<span>{leaseDetails.gross_leasable_area} sqft</span>)</p>
                                </div>
                                <div className="arrordianHeaderR d-flex justify-content-end align-items-center gap-5">
                                  <button title="Pause Alert" className="noBorderBgOutline" onClick={() => this.pauseAlert(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <svg className={leaseDetails.pause_status ? "warningColor" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                      <path fill="currentColor" d="M14 10h-2v12h2zm6 0h-2v12h2z" />
                                      <path fill="currentColor" d="M16 4A12 12 0 1 1 4 16A12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" />
                                    </svg>
                                  </button>
                                  <button title="Mark as Done" className="noBorderBgOutline" onClick={() => this.markAsDone(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <svg className={leaseDetails.mark_as_done ? "markAsDone" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                        <rect width="18" height="18" x="3" y="3" rx="4" />
                                        <path d="m9 12l2.25 2L15 10" />
                                      </g>
                                    </svg>
                                  </button>
                                  <button className="noBorderBgOutline">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 8.4c0-1.697-.632-3.325-1.757-4.525S13.59 2 12 2s-3.117.674-4.243 1.875C6.632 5.075 6 6.703 6 8.4C6 15.867 3 18 3 18h18s-3-2.133-3-9.6M13.73 21a2 2 0 0 1-3.46 0" />
                                    </svg>
                                  </button>
                                  <button title="Change Alert Date" className="noBorderBgOutline" onClick={() => this.editAlert(name.id, leaseDetails.lease_id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <path fill="none" stroke="currentColor" strokeWidth="1.5" d="m14.36 4.079l.927-.927a3.932 3.932 0 0 1 5.561 5.561l-.927.927m-5.56-5.561s.115 1.97 1.853 3.707C17.952 9.524 19.92 9.64 19.92 9.64m-5.56-5.561l-8.522 8.52c-.577.578-.866.867-1.114 1.185a6.556 6.556 0 0 0-.749 1.211c-.173.364-.302.752-.56 1.526l-1.094 3.281m17.6-10.162L11.4 18.16c-.577.577-.866.866-1.184 1.114a6.554 6.554 0 0 1-1.211.749c-.364.173-.751.302-1.526.56l-3.281 1.094m0 0l-.802.268a1.06 1.06 0 0 1-1.342-1.342l.268-.802m1.876 1.876l-1.876-1.876" />
                                    </svg>
                                  </button>
                                  <button title="Delete Alert" className="noBorderBgOutline opacity-0" onClick={() => this.deleteAlert(name.id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                      <path fill="currentColor" d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z" />
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            </>
                          ))


                          }
                          {
                            (typeof this.state.alertItems["rent"][name.id] == "undefined" || this.state.alertItems["rent"][name.id].length == 0) && (
                              <center><h7>No Data</h7></center>
                            )
                          }
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ), this)
                  }
                  {this.state.alertList["rent"].length == 0 && <p className="noDataFound">No data</p>}
                </TabPanel>
                <TabPanel>
                  {this.state.alertList["security"].map((name, index) => (
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item>
                        <Accordion.Header>
                          <div className="arrordianHeaderMain">
                            <div className="arrordianHeaderL">
                              <h4 onClick={() => this.loadAlertsList("security", name.id)}>{name.alert_name}</h4>
                            </div>
                            <div className="arrordianHeaderM">
                              <h4 className="text-center" onClick={() => this.loadAlertsList("security", name.id)}>
                                {name.created_at} <span>(Date Created)</span>
                              </h4>
                            </div>
                            <div className="arrordianHeaderR d-flex justify-content-end align-items-center gap-5 me-3">
                              <button title="Pause Alert" className="noBorderBgOutline" onClick={() => this.pauseAlert(name.id)}>
                                <svg className={name.pause_status ? "warningColor" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                  <path fill="currentColor" d="M14 10h-2v12h2zm6 0h-2v12h2z" />
                                  <path fill="currentColor" d="M16 4A12 12 0 1 1 4 16A12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" />
                                </svg>
                              </button>
                              <button title="Mark as Done" className="noBorderBgOutline" onClick={() => this.markAsDone(name.id)}>
                                <svg className={name.mark_as_done ? "markAsDone" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <g fill="white">
                                    <path d="M10.243 16.314L6 12.07l1.414-1.414l2.829 2.828l5.656-5.657l1.415 1.415z" />
                                    <path fill-rule="evenodd" d="M1 5a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4zm4-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2" clip-rule="evenodd" />
                                  </g>
                                </svg>
                              </button>
                              <button className="noBorderBgOutline">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 8.4c0-1.697-.632-3.325-1.757-4.525S13.59 2 12 2s-3.117.674-4.243 1.875C6.632 5.075 6 6.703 6 8.4C6 15.867 3 18 3 18h18s-3-2.133-3-9.6M13.73 21a2 2 0 0 1-3.46 0" />
                                </svg>
                              </button>
                              <button title="Change Alert Date" className="noBorderBgOutline" onClick={() => this.editAlert(name.id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <path fill="none" stroke="currentColor" stroke-width="1.5" d="m14.36 4.079l.927-.927a3.932 3.932 0 0 1 5.561 5.561l-.927.927m-5.56-5.561s.115 1.97 1.853 3.707C17.952 9.524 19.92 9.64 19.92 9.64m-5.56-5.561l-8.522 8.52c-.577.578-.866.867-1.114 1.185a6.556 6.556 0 0 0-.749 1.211c-.173.364-.302.752-.56 1.526l-1.094 3.281m17.6-10.162L11.4 18.16c-.577.577-.866.866-1.184 1.114a6.554 6.554 0 0 1-1.211.749c-.364.173-.751.302-1.526.56l-3.281 1.094m0 0l-.802.268a1.06 1.06 0 0 1-1.342-1.342l.268-.802m1.876 1.876l-1.876-1.876" />
                                </svg>
                              </button>
                              <button title="Delete Alert" className="noBorderBgOutline" onClick={() => this.deleteAlert(name.id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                  <path fill="currentColor" d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          {/* { typeof this.state.alertItems["security"][name.id] != "undefined" && this.state.alertItems["security"][name.id]].filter(filterItem => ( this.state.currentFilterStatus == 0 || (filterItem.pause_status == 1 && this.state.currentFilterStatus == 1 ) || ( this.state.currentFilterStatus == 2 && filterItem.mark_as_done == 1 ) || ( this.state.currentFilterStatus == 3 && filterItem.sent_status == 1 ) ) ).map((leaseDetails, index1) => ( */}
                          {typeof this.state.alertItems["security"][name.id] != "undefined" && this.state.alertItems["security"][name.id].filter(filterItem => (this.state.currentFilterStatus == 0 || (filterItem.pause_status == 1 && this.state.currentFilterStatus == 1) || (this.state.currentFilterStatus == 2 && filterItem.mark_as_done == 1) || (this.state.currentFilterStatus == 3 && filterItem.sent_status == 1))).map((leaseDetails, index1) => (
                            <>
                              {/* <div className="row my-3 bodyContentDiv">
                                <div className="col-lg-3">
                                  <h4>{leaseDetails.lease_code} </h4>
                                  <p>{leaseDetails.tower}, {leaseDetails.asset}</p>
                                </div>
                                <div className="col-lg-2">
                                  <h4>
                                    {leaseDetails.lease_expiry_date} <span>(in {leaseDetails.days_remaining} Days)</span>
                                  </h4>
                                </div>
                                <div className="col-lg-2">
                                  <h4>Rs.{leaseDetails.rent}</h4>
                                  <p>&nbsp;</p>
                                  <h4>Rs.{leaseDetails.rent} / mo Rent</h4>
                              <p>{leaseDetails.gross_leasable_area} sqft </p>
                                </div>
                                <div className={`col-lg-1 text-center ${leaseDetails.pause_status ? "warningColor" : ""}`}>
                                  <h4 onClick={() => this.pauseAlert(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <FontAwesomeIcon icon={faPauseCircle} />
                                  </h4 >
                                  <p>Pause Alert</p>
                                </div>
                                <div className={`col-lg-1 text-center ${leaseDetails.mark_as_done ? "markAsDone" : ""}`} >
                                  <h4 onClick={() => this.markAsDone(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <FontAwesomeIcon icon={faCheckCircle} />
                                  </h4>
                                  <p>Mark as Done</p>
                                </div>
                                <div className="col-lg-1 text-center">
                                  <h4 onClick={() => this.editAlert(name.id, leaseDetails.lease_id)} >
                                    <FontAwesomeIcon icon={faBell} />
                                  </h4>
                                  <p>Change Alert Date</p>
                                </div>
                                <div className="col-lg-1 text-center">
                                  <h4 onClick={() => this.editAlert(name.id, leaseDetails.lease_id)} >
                                    <FontAwesomeIcon icon={faPenSquare} />
                                  </h4>
                                  <p>Edit Alert</p>
                                </div>
                                <div className="col-lg-1 text-center">
                              <h4 onClick={() => this.editAlert(name.id,leaseDetails.lease_id)} >
                              <FontAwesomeIcon icon={faTrash} />
                              </h4>
                              <p>Delete Alert</p>
                            </div>
                              </div> */}
                              <div className="arrordianHeaderMain" key={index1}>
                                <div className="arrordianHeaderL">
                                  <h4>{leaseDetails.lease_code}</h4>
                                  <p>{leaseDetails.tower}, {leaseDetails.asset}</p>
                                </div>
                                <div className="arrordianHeaderM text-center">
                                  <h4>
                                    {leaseDetails.lease_expiry_date} <span>(in {leaseDetails.days_remaining} Days)</span>
                                  </h4>
                                  <p>Rs.{leaseDetails.rent}</p>
                                </div>
                                <div className="arrordianHeaderR d-flex justify-content-end align-items-center gap-5">
                                  <button title="Pause Alert" className="noBorderBgOutline" onClick={() => this.pauseAlert(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <svg className={leaseDetails.pause_status ? "warningColor" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                      <path fill="currentColor" d="M14 10h-2v12h2zm6 0h-2v12h2z" />
                                      <path fill="currentColor" d="M16 4A12 12 0 1 1 4 16A12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" />
                                    </svg>
                                  </button>
                                  <button title="Mark as Done" className="noBorderBgOutline" onClick={() => this.markAsDone(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <svg className={leaseDetails.mark_as_done ? "markAsDone" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                        <rect width="18" height="18" x="3" y="3" rx="4" />
                                        <path d="m9 12l2.25 2L15 10" />
                                      </g>
                                    </svg>
                                  </button>
                                  <button className="noBorderBgOutline">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 8.4c0-1.697-.632-3.325-1.757-4.525S13.59 2 12 2s-3.117.674-4.243 1.875C6.632 5.075 6 6.703 6 8.4C6 15.867 3 18 3 18h18s-3-2.133-3-9.6M13.73 21a2 2 0 0 1-3.46 0" />
                                    </svg>
                                  </button>
                                  <button title="Change Alert Date" className="noBorderBgOutline" onClick={() => this.editAlert(name.id, leaseDetails.lease_id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <path fill="none" stroke="currentColor" strokeWidth="1.5" d="m14.36 4.079l.927-.927a3.932 3.932 0 0 1 5.561 5.561l-.927.927m-5.56-5.561s.115 1.97 1.853 3.707C17.952 9.524 19.92 9.64 19.92 9.64m-5.56-5.561l-8.522 8.52c-.577.578-.866.867-1.114 1.185a6.556 6.556 0 0 0-.749 1.211c-.173.364-.302.752-.56 1.526l-1.094 3.281m17.6-10.162L11.4 18.16c-.577.577-.866.866-1.184 1.114a6.554 6.554 0 0 1-1.211.749c-.364.173-.751.302-1.526.56l-3.281 1.094m0 0l-.802.268a1.06 1.06 0 0 1-1.342-1.342l.268-.802m1.876 1.876l-1.876-1.876" />
                                    </svg>
                                  </button>
                                  <button title="Delete Alert" className="noBorderBgOutline opacity-0" onClick={() => this.deleteAlert(name.id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                      <path fill="currentColor" d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z" />
                                    </svg>
                                  </button>
                                </div>

                                {/* <div className="arrordianHeaderR d-flex justify-content-end align-items-center gap-5 me-4">
                                  <button className={`noBorderBgOutline ${leaseDetails.pause_status ? "warningColor" : ""}`} onClick={() => this.pauseAlert(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <FontAwesomeIcon icon={faPauseCircle} />
                                  </button>
                                  <button className={`noBorderBgOutline ${leaseDetails.mark_as_done ? "markAsDone" : ""}`} onClick={() => this.markAsDone(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <FontAwesomeIcon icon={faCheckCircle} />
                                  </button>
                                  <button title="Change Alert Date" className="noBorderBgOutline" onClick={() => this.editAlert(name.id, leaseDetails.lease_id)}>
                                    <FontAwesomeIcon icon={faBell} />
                                  </button>
                                  <button title="Change Alert Date" className="noBorderBgOutline" onClick={() => this.editAlert(name.id, leaseDetails.lease_id)}>
                                    <FontAwesomeIcon icon={faPenSquare} />
                                  </button>
                                </div> */}
                              </div>
                            </>
                          ))
                          }
                          {
                            (typeof this.state.alertItems["security"][name.id] == "undefined" || this.state.alertItems["security"][name.id].length == 0) && (
                              <center><h7>No Data</h7></center>
                            )
                          }
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ), this)
                  }
                  {this.state.alertList["security"].length == 0 && <p className="noDataFound">No data</p>}

                </TabPanel>
                <TabPanel>
                  {this.state.alertList["fitout-security"].map((name, index) => (
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item>
                        <Accordion.Header>
                          <div className="arrordianHeaderMain">
                            <div className="arrordianHeaderL">
                              <h4 onClick={() => this.loadAlertsList("fitout-security", name.id)}>{name.alert_name}</h4>
                            </div>
                            <div className="arrordianHeaderM">
                              <h4 className="text-center" onClick={() => this.loadAlertsList("fitout-security", name.id)}>
                                {name.created_at} <span>(Date Created)</span>
                              </h4>
                            </div>
                            <div className="arrordianHeaderR d-flex justify-content-end align-items-center gap-5 me-3">
                              <button title="Pause Alert" className="noBorderBgOutline" onClick={() => this.pauseAlert(name.id)}>
                                <svg className={name.pause_status ? "warningColor" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                  <path fill="currentColor" d="M14 10h-2v12h2zm6 0h-2v12h2z" />
                                  <path fill="currentColor" d="M16 4A12 12 0 1 1 4 16A12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" />
                                </svg>
                              </button>
                              <button title="Mark as Done" className="noBorderBgOutline" onClick={() => this.markAsDone(name.id)}>
                                <svg className={name.mark_as_done ? "markAsDone" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <g fill="currentColor">
                                    <path d="M10.243 16.314L6 12.07l1.414-1.414l2.829 2.828l5.656-5.657l1.415 1.415z" />
                                    <path fill-rule="evenodd" d="M1 5a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4zm4-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2" clip-rule="evenodd" />
                                  </g>
                                </svg>
                              </button>
                              <button className="noBorderBgOutline">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 8.4c0-1.697-.632-3.325-1.757-4.525S13.59 2 12 2s-3.117.674-4.243 1.875C6.632 5.075 6 6.703 6 8.4C6 15.867 3 18 3 18h18s-3-2.133-3-9.6M13.73 21a2 2 0 0 1-3.46 0" />
                                </svg>
                              </button>
                              <button title="Change Alert Date" className="noBorderBgOutline" onClick={() => this.editAlert(name.id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                  <path fill="none" stroke="currentColor" stroke-width="1.5" d="m14.36 4.079l.927-.927a3.932 3.932 0 0 1 5.561 5.561l-.927.927m-5.56-5.561s.115 1.97 1.853 3.707C17.952 9.524 19.92 9.64 19.92 9.64m-5.56-5.561l-8.522 8.52c-.577.578-.866.867-1.114 1.185a6.556 6.556 0 0 0-.749 1.211c-.173.364-.302.752-.56 1.526l-1.094 3.281m17.6-10.162L11.4 18.16c-.577.577-.866.866-1.184 1.114a6.554 6.554 0 0 1-1.211.749c-.364.173-.751.302-1.526.56l-3.281 1.094m0 0l-.802.268a1.06 1.06 0 0 1-1.342-1.342l.268-.802m1.876 1.876l-1.876-1.876" />
                                </svg>
                              </button>
                              <button title="Delete Alert" className="noBorderBgOutline" onClick={() => this.deleteAlert(name.id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                  <path fill="currentColor" d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          {/* { typeof this.state.alertItems["security"][name.id] != "undefined" && this.state.alertItems["security"][name.id]].filter(filterItem => ( this.state.currentFilterStatus == 0 || (filterItem.pause_status == 1 && this.state.currentFilterStatus == 1 ) || ( this.state.currentFilterStatus == 2 && filterItem.mark_as_done == 1 ) || ( this.state.currentFilterStatus == 3 && filterItem.sent_status == 1 ) ) ).map((leaseDetails, index1) => ( */}
                          {typeof this.state.alertItems["fitout-security"][name.id] != "undefined" && this.state.alertItems["fitout-security"][name.id].filter(filterItem => (this.state.currentFilterStatus == 0 || (filterItem.pause_status == 1 && this.state.currentFilterStatus == 1) || (this.state.currentFilterStatus == 2 && filterItem.mark_as_done == 1) || (this.state.currentFilterStatus == 3 && filterItem.sent_status == 1))).map((leaseDetails, index1) => (
                            <>
                              {/* <div className="row my-3 bodyContentDiv">
                                <div className="col-lg-3">
                                  <h4>{leaseDetails.lease_code} </h4>
                                  <p>{leaseDetails.tower}, {leaseDetails.asset}</p>
                                </div>
                                <div className="col-lg-2">
                                  <h4>
                                    {leaseDetails.lease_expiry_date} <span>(in {leaseDetails.days_remaining} Days)</span>
                                  </h4>
                                </div>
                                <div className="col-lg-2">
                                  <h4>Rs.{leaseDetails.rent}</h4>
                                  <p>&nbsp;</p>
                                  <h4>Rs.{leaseDetails.rent} / mo Rent</h4>
                              <p>{leaseDetails.gross_leasable_area} sqft </p>
                                </div>
                                <div className={`col-lg-1 text-center ${leaseDetails.pause_status ? "warningColor" : ""}`}>
                                  <h4 onClick={() => this.pauseAlert(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <FontAwesomeIcon icon={faPauseCircle} />
                                  </h4 >
                                  <p>Pause Alert</p>
                                </div>
                                <div className={`col-lg-1 text-center ${leaseDetails.mark_as_done ? "markAsDone" : ""}`} >
                                  <h4 onClick={() => this.markAsDone(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <FontAwesomeIcon icon={faCheckCircle} />
                                  </h4>
                                  <p>Mark as Done</p>
                                </div>
                                <div className="col-lg-1 text-center">
                                  <h4 onClick={() => this.editAlert(name.id, leaseDetails.lease_id)} >
                                    <FontAwesomeIcon icon={faBell} />
                                  </h4>
                                  <p>Change Alert Date</p>
                                </div>
                                <div className="col-lg-1 text-center">
                                  <h4 onClick={() => this.editAlert(name.id, leaseDetails.lease_id)} >
                                    <FontAwesomeIcon icon={faPenSquare} />
                                  </h4>
                                  <p>Edit Alert</p>
                                </div>
                                <div className="col-lg-1 text-center">
                              <h4 onClick={() => this.editAlert(name.id,leaseDetails.lease_id)} >
                              <FontAwesomeIcon icon={faTrash} />
                              </h4>
                              <p>Delete Alert</p>
                            </div>
                              </div> */}
                              <div className="arrordianHeaderMain" key={index1}>
                                <div className="arrordianHeaderL">
                                  <h4>{leaseDetails.lease_code}</h4>
                                  <p>{leaseDetails.tower}, {leaseDetails.asset}</p>
                                </div>
                                <div className="arrordianHeaderM text-center">
                                  <h4>
                                    {leaseDetails.lease_expiry_date} <span>(in {leaseDetails.days_remaining} Days)</span>
                                  </h4>
                                  <p>Rs.{leaseDetails.rent}</p>
                                </div>
                                <div className="arrordianHeaderR d-flex justify-content-end align-items-center gap-5">
                                  <button title="Pause Alert" className="noBorderBgOutline" onClick={() => this.pauseAlert(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <svg className={leaseDetails.pause_status ? "warningColor" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                      <path fill="currentColor" d="M14 10h-2v12h2zm6 0h-2v12h2z" />
                                      <path fill="currentColor" d="M16 4A12 12 0 1 1 4 16A12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" />
                                    </svg>
                                  </button>
                                  <button title="Mark as Done" className="noBorderBgOutline" onClick={() => this.markAsDone(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}>
                                    <svg className={leaseDetails.mark_as_done ? "markAsDone" : ""} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                        <rect width="18" height="18" x="3" y="3" rx="4" />
                                        <path d="m9 12l2.25 2L15 10" />
                                      </g>
                                    </svg>
                                  </button>
                                  <button className="noBorderBgOutline">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 8.4c0-1.697-.632-3.325-1.757-4.525S13.59 2 12 2s-3.117.674-4.243 1.875C6.632 5.075 6 6.703 6 8.4C6 15.867 3 18 3 18h18s-3-2.133-3-9.6M13.73 21a2 2 0 0 1-3.46 0" />
                                    </svg>
                                  </button>
                                  <button title="Change Alert Date" className="noBorderBgOutline" onClick={() => this.editAlert(name.id, leaseDetails.lease_id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                      <path fill="none" stroke="currentColor" strokeWidth="1.5" d="m14.36 4.079l.927-.927a3.932 3.932 0 0 1 5.561 5.561l-.927.927m-5.56-5.561s.115 1.97 1.853 3.707C17.952 9.524 19.92 9.64 19.92 9.64m-5.56-5.561l-8.522 8.52c-.577.578-.866.867-1.114 1.185a6.556 6.556 0 0 0-.749 1.211c-.173.364-.302.752-.56 1.526l-1.094 3.281m17.6-10.162L11.4 18.16c-.577.577-.866.866-1.184 1.114a6.554 6.554 0 0 1-1.211.749c-.364.173-.751.302-1.526.56l-3.281 1.094m0 0l-.802.268a1.06 1.06 0 0 1-1.342-1.342l.268-.802m1.876 1.876l-1.876-1.876" />
                                    </svg>
                                  </button>
                                  <button title="Delete Alert" className="noBorderBgOutline opacity-0" onClick={() => this.deleteAlert(name.id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                                      <path fill="currentColor" d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z" />
                                    </svg>
                                  </button>
                                </div>
                                {/* <div className="arrordianHeaderR d-flex justify-content-end align-items-center gap-5 me-4">
                                  <button
                                    className={`noBorderBgOutline ${leaseDetails.pause_status ? "warningColor" : ""}`}
                                    onClick={() => this.pauseAlert(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}
                                  >
                                    <FontAwesomeIcon icon={faPauseCircle} />
                                  </button>
                                  <button
                                    className={`noBorderBgOutline ${leaseDetails.mark_as_done ? "markAsDone" : ""}`}
                                    onClick={() => this.markAsDone(name.id, leaseDetails.lease_id, leaseDetails.frequency, leaseDetails.lease_expiry_date)}
                                  >
                                    <FontAwesomeIcon icon={faCheckCircle} />
                                  </button>
                                  <button
                                    className="noBorderBgOutline"
                                    onClick={() => this.editAlert(name.id, leaseDetails.lease_id)}
                                  >
                                    <FontAwesomeIcon icon={faBell} />
                                  </button>
                                  <button
                                    className="noBorderBgOutline"
                                    onClick={() => this.editAlert(name.id, leaseDetails.lease_id)}
                                  >
                                    <FontAwesomeIcon icon={faPenSquare} />
                                  </button>
                                </div> */}
                              </div>
                            </>
                          ))
                          }
                          {
                            (typeof this.state.alertItems["fitout-security"][name.id] == "undefined" || this.state.alertItems["fitout-security"][name.id].length == 0) && (
                              <center><h7>No Data</h7></center>
                            )
                          }
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ), this)
                  }
                  {this.state.alertList["fitout-security"].length == 0 && <p className="noDataFound">No data</p>}

                </TabPanel>
              </div>

            </Tabs>
          </div>
        </div>
        <Modal
          show={this.state.isModalOpen}
          onHide={this.closeModal}
          size="xl"
          className="documentModal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <div className="container modalBreadCrumbs">
                <div className="row">
                  <div className="col-lg-12">
                    <ul>
                      <li>Add Alert</li>
                    </ul>
                  </div>
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ backgroundColor: "#fff" }}>
            <Formik
              validationSchema={Schema}
              initialValues={this.state.initialValues}
              enableReinitialize
            //onSubmit={this.submitForm}

            // onSubmit={(values, actions) => {
            //   console.log("oye jhjoe");
            //   if (!this.validator.allValid()) {
            //     this.validator.showMessages();
            //     return false;
            //   }
            //   values.emails = this.state.emails;
            //   values.assetId = this.state.initialValues.assetId;
            //   values.brandId = this.state.initialValues.brandId;
            //   console.log(values, "values");

            //   var self = this;
            //   axios({
            //     method: "post",
            //     url: this.state.url,
            //     data: values,
            //   }).then(function (response) {
            //     if (!response.data.success) {
            //       actions.setSubmitting(false);
            //       actions.setErrors(response.data);
            //       alert(response.data.message);
            //     } else {
            //       self.setState({
            //         messsagePopup: true,
            //         popupContent: "Data Saved Successfully",
            //       });
            //       self.setState({
            //         // url: `${apiUrl.apiUrl.url}/asset/create-tower`,
            //         // self.setState({ redirect: true });
            //         redirect: true,
            //         emails: [],
            //         frequencySelected: [],
            //         isOpen: false,
            //         initialValuesAlertSettings: {
            //           assetTypeId: "",
            //           assetId: "",
            //           subAssetId: "",
            //           towerName: "",
            //           assetName: "",
            //           subAssetName: "",
            //           assetType: "",
            //           countryId: "",
            //           stateId: "",
            //           districtId: "",
            //           cityId: "",
            //           frequencySelected: [],
            //         },
            //       });
            //     }
            //   });
            // }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <form autoComplete="off" onSubmit={handleSubmit}>
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">
                          <div className="newGridSectionInner">
                            <label>Alert Name</label>
                            <div className="position-relative">
                              <Field
                                type="text"
                                name="alertName"
                                value={this.state.initialValues.alertName}
                                onChange={(e) => {
                                  this.valueChange(e, "change_alert");
                                }}
                              />
                              <ErrorMessage name="alertName" component="div" className="text-red" />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Alert Type</label>
                            <div className="position-relative">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                styles={selectStyles}
                                name="reportType"
                                onChange={(e) => {
                                  this.state.initialValues.reportType = e.label;
                                  this.state.initialValues.reportId = e.value;
                                  this.setState({});
                                }}
                                value={{
                                  label: this.state.initialValues.reportType,
                                  value: this.state.initialValues.reportId,
                                }}
                                options={[
                                  { value: "expiry", label: "Lease Expiry" },
                                  { value: "lockin", label: "Lease Lockin" },
                                  { value: "Rent", label: "Lease Rent" },
                                  { value: "security", label: "Security Deposit" },
                                  { value: "fitout-security", label: "Fitout Security Deposit" },
                                ]}
                              />
                              <ErrorMessage name="reportType" component="div" className="text-red" />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Alert Text</label>
                            <div className="position-relative">
                              <textarea
                                name="alertText"
                                onChange={(e) => {
                                  this.valueChange(e, "change_alert_text");
                                }}
                                value={this.state.initialValues.alertText}
                              ></textarea>
                              <ErrorMessage name="alertText" component="div" className="text-red" />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Region</label>
                            <div className="position-relative">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="regionId"
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_region");
                                }}
                                //
                                //this.state.initialValues.selectedStates
                                value={{
                                  label: this.state.initialValues.regionName,
                                  value: this.state.initialValues.regionId,
                                }}
                                options={this.state.regionList.map((item) => ({
                                  label: item.region_name,
                                  value: item.region_name,
                                }))}
                              />
                              {/* <ErrorMessage name="stateName" component="div" className="text-red" /> */}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>State</label>
                            <div className="position-relative">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="assetId"
                                onChange={(e) => {
                                  this.valueChange(e, "change_state");
                                }}
                                value={{
                                  label: this.state.initialValues.stateName,
                                  value: this.state.initialValues.stateId,
                                }}
                                options={this.state.states.map((item) => ({
                                  label: item.state_name,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage name="stateName" component="div" className="text-red" />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Brand Name</label>
                            <div className="position-relative">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="brandSelected"
                                isMulti
                                closeMenuOnSelect={true}
                                onInputChange={this.handleChange}
                                onChange={(e) => {
                                  this.valueChange(e, "change_brand");
                                }}
                                value={this.state.initialValues.brandSelected}
                                options={this.state.brandList.map((item) => ({
                                  label: item.brand_name,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage name="brandSelected" component="div" className="text-red" />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Asset Name</label>
                            <div className="position-relative">
                              <Select
                                isMulti
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="assetSelected"
                                onInputChange={this.getAssetsList}
                                onChange={(e) => {
                                  this.valueChange(e, "change_asset_name");
                                }}
                                value={this.state.initialValues.assetSelected}
                                options={this.state.assetsList.map((item) => ({
                                  label: item.asset_name,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage name="assetSelected" component="div" className="text-red" />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Lease ID</label>
                            <div className="position-relative">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="leaseSelected"
                                isMulti
                                onInputChange={this.handleChange}
                                onChange={(e) => {
                                  this.valueChange(e, "change_lease_number");
                                }}
                                value={this.state.leaseSelected}
                                options={this.state.leaseList.map((item) => ({
                                  label: item.lease_code,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage name="leaseSelected" component="div" className="text-red" />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Email</label>
                            <div className="position-relative">
                              <ReactMultiEmail
                                className="reactMultiEmailClass"
                                emails={this.state.initialValues.emails}
                                onKeyPress={(e) => { }}
                                onChange={(_emails: string[]) => {
                                  this.state.initialValues.emails = _emails;
                                  this.setState({});
                                }}
                                getLabel={(email: string, index: number, removeEmail: (index: number) => void) => {
                                  return (
                                    <div data-tag key={index}>
                                      {email}
                                      <span data-tag-handle onClick={() => removeEmail(index)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                          <path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z" />
                                        </svg>
                                      </span>
                                    </div>
                                  );
                                }}
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Frequency</label>
                            <div className="position-relative">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="frequencySelected"
                                isMulti
                                onInputChange={this.handleChange}
                                onChange={(e) => {
                                  this.frequencyChange(e);
                                }}
                                value={this.state.initialValues.frequencySelected}
                                required
                                options={[
                                  { label: "6 Months", value: 6 },
                                  { label: "5 Months", value: 5 },
                                  { label: "4 Months", value: 4 },
                                  { label: "3 Months", value: 3 },
                                  { label: "2 Months", value: 2 },
                                  { label: "1 Months", value: 1 },
                                  { label: "15 Days", value: "15 Days" },
                                ]}
                              />
                              <ErrorMessage name="frequencySelected" component="div" className="text-red" />
                            </div>
                          </div>


                        </div>
                        <div className="button_group d-flex align-items-center gap-2 justify-content-end mt-3">
                          <button
                            className="add_button"
                            onClick={this.submitForm}
                          >
                            Save
                          </button>
                          <button
                            className="reset_button"
                            type="reset"
                            onClick={(e) => {
                              this.resetForm(values);
                              this.closeModal();
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

                  {/* <form onSubmit={handleSubmit}>

                    <div className="container-fluid add_edit_modal">
                      <div className="row">
                        <div
                          className="col-12 col-sm-6 col-lg-6 leftSideAlertForm"
                        >
                          <div className="row customGapSpacing">
                            <div className="col-lg-4">
                              <label>Alert Name</label>
                            </div>
                            <div className="col-lg-8">
                              <Field
                                type="text"
                                name="alertName"
                                value={this.state.initialValues.alertName}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_alert");
                                }}
                              />
                              <ErrorMessage
                                name="alertName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                            <div className="col-lg-4">
                              <label>Alert Type</label>
                            </div>
                            <div className="col-lg-8">
                              <Select
                                //menuIsOpen={true}
                                className="alertTypeClass"
                                classNamePrefix="alertTypeClassInner"
                                styles={selectStyles}
                                name="reportType"
                                onChange={(e) => {
                                  this.state.initialValues.reportType = e.label;
                                  this.state.initialValues.reportId = e.value;
                                  this.setState({});
                                }}
                                value={{
                                  label: this.state.initialValues.reportType,
                                  value: this.state.initialValues.reportId,
                                }}
                                options={[
                                  {
                                    value: "expiry",
                                    label: "Lease Expiry",
                                  }, {
                                    value: "lockin",
                                    label: "Lease Lockin",
                                  },
                                  {
                                    value: "Rent",
                                    label: "Lease Rent",
                                  },
                                  {
                                    value: "security",
                                    label: "Security Deposit",
                                  },
                                  {
                                    value: "fitout-security",
                                    label: "Fitout Security Deposit",
                                  },
                                ].map((item) => ({
                                  label: item.label,
                                  value: item.value,
                                }))}
                              />
                              <ErrorMessage
                                name="reportType"
                                component="div"
                                className="text-red"
                              />
                            </div>


                            <div className="col-lg-4">
                              <p>Alert Text</p>
                            </div>
                            <div className="col-lg-8">

                              <textarea
                                // style={{ width: "90%" }}
                                name="alertText"
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_alert_text");
                                }}
                                value={this.state.initialValues.alertText}
                              ></textarea>
                              <ErrorMessage
                                name="alertText"
                                component="div"
                                className="text-red"
                              />

                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-6 rightSideAlertForm"  >
                          <div className="row customGapSpacing">
                            <div className="col-lg-4">
                              <label>State</label>
                            </div>
                            <div className="col-lg-8">
                              <Select
                                //isMulti
                                // className="basic-single custom-select-style"
                                className="alertTypeClass"
                                classNamePrefix="alertTypeClassInner"
                                name="assetId"
                                //onInputChange={this.getAssetsList}
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_state");
                                }}
                                //
                                //this.state.initialValues.selectedStates
                                value={{
                                  label: this.state.initialValues.stateName,
                                  value: this.state.initialValues.stateId,
                                }}
                                options={this.state.states.map((item) => ({
                                  label: item.state_name,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage
                                name="stateName"
                                component="div"
                                className="text-red"
                              />

                            </div>


                            <div className="col-lg-4">
                              <label>Brand Name</label>
                            </div>
                            <div className="col-lg-8">
                              <Select
                                className="alertTypeClass"
                                classNamePrefix="alertTypeClassInner"
                                name="brandSelected"
                                isMulti
                                closeMenuOnSelect={true}
                                onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  this.valueChange(e, "change_brand");
                                }}
                                value={
                                  this.state.initialValues.brandSelected
                                }
                                options={this.state.brandList.map((item) => ({
                                  label: item.brand_name,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage
                                name="brandSelected"
                                component="div"
                                className="text-red"
                              />
                            </div>

                            <div className="col-lg-4">
                              <label>Asset Name</label>
                            </div>
                            <div className="col-lg-8">
                              <Select
                                isMulti
                                // className="basic-single custom-select-style"

                                className="alertTypeClass"
                                classNamePrefix="alertTypeClassInner"
                                name="assetSelected"
                                onInputChange={this.getAssetsList}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_asset_name");
                                }}
                                value={
                                  this.state.initialValues.assetSelected
                                }
                                options={this.state.assetsList.map((item) => ({
                                  label: item.asset_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="assetSelected"
                                component="div"
                                className="text-red"
                              />
                            </div>

                            <div className="col-lg-4">
                              <label>Lease ID</label>
                            </div>
                            <div className="col-lg-8">
                              <Select
                                // className="basic-single custom-select-style"
                                // 
                                className="alertTypeClass"
                                classNamePrefix="alertTypeClassInner"
                                name="leaseSelected"
                                isMulti
                                onInputChange={this.handleChange}
                                onChange={(e) => {
                                  this.valueChange(e, "change_lease_number");
                                }}
                                value={this.state.leaseSelected}
                                options={this.state.leaseList.map((item) => ({
                                  label: item.lease_code,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage
                                name="leaseSelected"
                                component="div"
                                className="text-red"
                              />
                            </div>

                            <div className="col-lg-4">
                              <label>Email</label>
                            </div>
                            <div className="col-lg-8">
                              <ReactMultiEmail
                                className="alertEmailClass"
                                //  classNamePrefix="alertTypeClassInner"
                                // placeholder="Input your Email Address"
                                
                                emails={this.state.initialValues.emails}
                                onKeyPress={(e) => { }}
                                onChange={(_emails: string[]) => {
                                  this.state.initialValues.emails = _emails;
                                  this.setState({});
                                }}
                                getLabel={(
                                  email: string,
                                  index: number,
                                  removeEmail: (index: number) => void
                                ) => {
                                  return (
                                    <div data-tag key={index}>
                                      {email}
                                      <span
                                        data-tag-handle
                                        onClick={() => removeEmail(index)}
                                      >
                                        x
                                      </span>
                                    </div>
                                  );
                                }}
                              />
                            </div>

                            <div className="col-lg-4">
                              <label>Frequency</label>
                            </div>
                            <div className="col-lg-8">
                              <Select
                                // className="basic-single custom-select-style"

                                className="alertTypeClass"
                                name="frequencySelected"
                                isMulti
                                onInputChange={this.handleChange}
                                onChange={(e) => {
                                  this.frequencyChange(e);
                                }}
                                value={this.state.initialValues.frequencySelected}
                                required
                                options={[
                                  { label: "6 Months", value: 6 },
                                  { label: "5 Months", value: 5 },
                                  { label: "4 Months", value: 4 },
                                  { label: "3 Months", value: 3 },
                                  { label: "2 Months", value: 2 },
                                  { label: "1 Months", value: 1 },
                                  {
                                    label: "15 Days",
                                    value: "15 Days",
                                  },
                                ].map((item) => ({
                                  label: item.label,
                                  value: item.label,
                                }))}
                              />

                            </div>
                            <ErrorMessage
                              name="frequencySelected"
                              component="div"
                              className="text-red"
                            />
                            <div className="col-lg-12 d-flex align-items-center text-end mt-3">

                              <button
                                // type="submit"
                                //form="fooId"
                                style={{
                                  maxWidth: "80%",
                                  width: "100%",
                                  padding: "5px",
                                  marginLeft: "15px",
                                }}
                                onClick={this.submitForm}
                              >
                                Save
                              </button>
                              <button
                                type="reset"
                                style={{
                                  maxWidth: "80%",
                                  width: "100%",
                                  padding: "5px",
                                  marginLeft: "15px",
                                }}
                                //onClick={this.closeModal}
                                onClick={(e) => {
                                  this.resetForm(values);
                                  this.closeModal();
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form> */}
                </>
              )}
            </Formik>
          </Modal.Body>
          {/* <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.closeModal}
              >
                Close
              </Button>
            </Modal.Footer> */}
        </Modal>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
      </>
    );
  }
}
export default withRouter(UserNotification);
